import forumlaColumns from '../../components/Formula/editor/forumlaColumns'
import taskRawColumns from '../../components/Formula/editor/taskRawColumns'
import formulaRawColumns from '../../components/Formula/modal/formulaRawColumns.js'
import formulaMixRawColumns from '../../components/Formula/modal/formulaMixRawColumns.js'
import formulaNutritionColumns from '../../components/Formula/modal/formulaNutritionColumns.js'
import {setStoreageColumns} from '../utils'

const formula = {
  namespaced: true,
  state: () => ({
    layout: {
      showSider: true,
      showRight: true,
      layoutType: false,
    },
    visible: {
      raw: false,
      nut: false,
      result: false,
      formula: false,
      assess:false,
      replace:false,
      formulaDetail:false,
      formulaMixDetail:false,
      taskRaw:false,
      batchAddRaw: false,
      batchAddRawImport: false,
      batchDeleteRaw:false,
      batchReplaceRaw:false,
      batchModifyRaw:false,
      batchNutrition:false,
      batchAddRawList:false,
      resTask:false,
      resProduct:false,
      reportConfirmVisible: false
    },
    reportVisible: false,
    progressVisible: false,
    progressPercent: 0,
    progressModalTitle: '',
    progressModalBtnText: '',
    progressModalContent: '',
    progressType: false,
    progressModalUrl: '',
    // 多任务配方详情
    detail: { },
    resRaw:0,
    resNut:0,
    height: 0,
    nutSelect: {},
    rawSelect: { rawName: "", percentage: 0 },
    rawRows: [],
    nutRows: [],
    rawResult: [], // 计算结果
    formula:{}, // 配方
    taskRaw:{}, // 全集原料
    formulaList:[],
    formulaSelectedRows: [],  // 多配方 批量选中
    formulaSelectedRowKeys: [],
    forumlaColumns:setStoreageColumns('forumlaColumns',forumlaColumns),
    taskRawColumns:setStoreageColumns('taskRawColumns',taskRawColumns),
    formulaRawColumns:setStoreageColumns('formulaRawColumns',formulaRawColumns),
    formulaMixRawColumns,
    formulaNutritionColumns:setStoreageColumns('formulaNutritionColumns',formulaNutritionColumns),
    reportKey: 0,
  }),
  mutations: {
    toggleVisible(state, name) {
      let status = {};
      status[name] = !state.visible[name];
      state.visible = { ...state.visible, ...status };
    },
    setState(state, payload) {
      for (let i in payload) {
        state[i] = payload[i];
      }
    },
  },
};
export default formula;
